<div class="padding-b-70">
   <div class="contentBox">
      <div class="border-top padding-t-30">
         <ul class="image-tabs flex font-15">
            <!-- <li class="wow fadeInUp"
                [ngClass]="{'selected': brandSelect === 'deserve'}" (click)="brandSelect = 'deserve'"
                data-wow-duration="500ms" data-wow-delay="50ms">
               <div class="icon brand-icon">
                  <img src="assets/images/deserve.png" class="active" alt="">
                  <img src="assets/images/deserve-grey.png" class="inactive" alt="">
               </div>
            </li> -->
            <li class="wow fadeInUp"
                [ngClass]="{'selected': brandSelect === 'bsi'}" (click)="brandSelect = 'bsi'"
                data-wow-duration="500ms" data-wow-delay="50ms">
               <div class="icon brand-icon">
                  <img src="assets/images/bsi.png" class="active" alt="">
                  <img src="assets/images/bsi-grey.png" class="inactive" alt="">
               </div>
            </li>
         </ul>
      </div>

      <!--      ...... Deserve .....-->
      <!-- <ul class="brand-details-list team-list font-16 line-25" *ngIf="brandSelect === 'deserve'">
         <li class="no-border">
            <div class="">

               <div class="">
                  <div class="margin-b-10  wow fadeInUp flex"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <a href="http://www.deservecards.com" target="_blank"
                        class="highlight-color proximaNovaSb">
                        http://www.deservecards.com
                     </a>
                     <a href="https://www.deserve.com" target="_blank"
                        class="highlight-color proximaNovaSb margin-l-30">
                        https://www.deserve.com
                     </a>
                  </div>
                  <div class="wow fadeInUp margin-b-15"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Deserve is powering the future of fintech through digital-first, mobile-centric, highly
                     configurable API and SDK based credit card solutions. Using machine learning and alternative data,
                     Deserve provides partners with state of the art underwriting solutions that expand financial
                     access. Deserve partners with financial institutions, fintechs, and modern consumer brands,
                     universities and associations to develop, rapidly deploy and power white label and co-branded
                     credit card programs. Deserve is a venture-backed fintech company whose investors include Goldman
                     Sachs, Sallie Mae, Accel, Pelion Venture Partners, Aspect Ventures, and Mission Holdings. Credit
                     Cards are issued by Celtic Bank, a Utah Chartered Industrial Bank, Member FDIC and Evolve Bank and
                     Trust, Member FDIC. Connect with Deserve on Facebook, LinkedIn, and Twitter.
                   </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Mission Holdings is a shareholder of Deserve Inc and Saurabh Mittal serves on the board of Deserve
                     Inc.
                  </div>
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/Kalpesh-Kapadia.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Kalpesh Kapadia</div>
                  <div class="font-14 light-color proximaNovaSb">CEO & Co-Founder, Deserve</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Kalpesh Kapadia’s career spans 20+ years in the US and Asia, primarily in technology and finance. He
                  came to the US over 25 years ago as a young student and struggled to establish his credit profile. In
                  2013, Kalpesh co-founded
                  <a href="https://www.deservecards.com/" target="_blank" class="highlight-color">Deserve</a>,
                  a Cloud based, API centric software platform that enables a
                  delightful digital/mobile cardholder experience for consumers and Modern card program management for
                  partners supported by a full suite of reward, reporting, analytics, and customer service. Prior to
                  co-founding Deserve he was one of the foremost analyst/investors in Wall Street’s tech sector. In 2004
                  he was ranked the #1 analyst in the US across all sectors by the venerable
                  <a href="http://www.wsj.com/news/articles/SB108420624811206837" class="highlight-color"
                     target="_blank">
                     Wall Street Journal
                  </a>. In
                  2005 he founded Equanum Capital and successfully managed it through 2012. In ’07 and ’09, Equanum
                  Funds were one of the best managed global equity funds in
                  <a href="https://www.barrons.com/?r=1" class="highlight-color" target="_blank">Barrons.com</a> and
                  <a href="http://www.hedgefundintelligence.com/news/asia-pacific" class="highlight-color"
                     target="_blank">
                     Asiahedge
                  </a> rankings. He
                  earned an MBA from Tepper School of Business at Carnegie Mellon University where he serves on the
                  <a href="https://www.cmu.edu/tepper/alumni/alumni-board/index.html" class="highlight-color"
                     target="_blank">
                     alumni board
                  </a> and as a proud member of
                  <a href="http://alumnihub.tepper.cmu.edu/s/1410/alumni/tepper/index.aspx?sid=1410&gid=25&pgid=4637"
                     class="highlight-color" target="_blank">
                     W.L. Mellon Society
                  </a>. He also holds an MS in Industrial
                  Engineering and Operations Research from New Jersey Institute of Technology. His personal and
                  charitable interests focus on empowerment and upliftment through higher education. Kalpesh is a
                  member/supporter of organizations such as
                  <a href="https://www.cato.org/" class="highlight-color" target="_blank">Cato Institute</a>,
                  <a href="http://www.santafe.edu/" class="highlight-color" target="_blank">Santa Fe Institute</a>,
                  <a href="https://ffe.org/" class="highlight-color" target="_blank">Foundation for Excellence</a>,
                  <a href="https://www.indiaspora.org/about/patrons/" class="highlight-color" target="_blank">
                     Indiaspora
                  </a> and
                  <a href="http://www.himalayan-foundation.org/" class="highlight-color" target="_blank">
                     American Himalayan Foundation
                  </a>. He is also a member of Bay Area chapters of
                  <a href="https://www.commonwealthclub.org/" class="highlight-color" target="_blank">
                     Commonwealth Club</a>
                  and <a href="https://www.churchillclub.org/" class="highlight-color" target="_blank">
                  the Churchill Club</a>.
               </div>
            </div>
         </li>
      </ul> -->

      <!--      ...... BSI .....-->
      <ul class="brand-details-list team-list font-16 line-25" *ngIf="brandSelect === 'bsi'">
         <li class="no-border">
            <div class="">
               <div class="">
                  <div class="margin-b-10  wow fadeInUp flex"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <a href="https://www.bsifinancial.com" target="_blank" class="highlight-color proximaNovaSb">
                        www.bsifinancial.com
                     </a>
                     <a href="http://www.bizzylabs.tech" target="_blank"
                        class="highlight-color proximaNovaSb margin-l-30">
                        http://www.bizzylabs.tech
                     </a>
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     BSI is leading the evolution of mortgage servicing for originators, investors and home-owners.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Our cloud based, open API and AI driven platform is built from the ground up to transform the
                     mortgage servicing experience for all stakeholders. Our end-to-end digital servicing platform
                     enables investors and originators to transact seamlessly, with automated loan boarding, investor
                     reporting and data-driven loan monitoring through the lifecycle of the mortgage. Our digital
                     homeowner interface offers the convenience of mobile friendly UX and multi-channel service that
                     ensures high customer retention and satisfaction, further enhancing the value proposition for
                     originators and investors.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     We have build a proprietary AI-driven compliance automation and workflow that ensures complex,
                     state-by-state regulations are kept up-to-date and acted on with precision and certainty, providing
                     real-time visibility into the mortgage details and exceptions.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Bizzy Labs, our subsidiary, offers this as a SaaS RegTech solution to external servicers &
                     investors.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     BSI brings together a talented team with long mortgage industry expertise, scalable digital
                     capabilities and deep regulatory understanding. With more than $50 billion of servicing, BSI is one
                     of the fastest growing mortgage servicers across the industry.
                  </div>

                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Mission Holdings is the majority economic owner of BSI and Saurabh Mittal serves as a board member.
                  </div>
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/gaganSharma.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Gagan Sharma</div>
                  <div class="font-14 light-color proximaNovaSb line-20">
                     Founder and CEO, BSI Financial Services and Bizzy Labs
                  </div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Gagan is a seasoned entrepreneur and executive with 20+ years of experience in financial services and
                  technology. He enjoys solving challenging customer problems in the financial sector and has a proven
                  track record of bringing startup concepts to life and scaling for success.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Since leading an investment group to acquire BSI from a bank in 2006, he has transformed the company
                  from a small loan servicer into a fast growing and leading nationwide mortgage fintech, fostering a
                  70X growth since the acquisition. BSI was recently named on the Inc. Magazines’ Inc. 5000 list of
                  fastest growing companies for two years and on The Dallas 100 list of fastest growing companies in
                  North Texas for four consecutive years. Gagan was the finalist for the EY Entrepreneur of the Year in
                  the Southwest Region in 2017. He is a member of Young Presidents’ Organization (YPO) and Chairman of
                  the Consumer Finance Network within YPO.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to BSI, Gagan dropped out of The Wharton School to start, scale and sell a successful global
                  financial services and technology outsourcing company. Gagan has an MBA from The Wharton School at The
                  University of Pennsylvania and a B Tech from the Indian Institute of Technology, Delhi.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/larryGoldstone.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Larry Goldstone</div>
                  <div class="font-14 light-color proximaNovaSb line-20">President of Capital Markets and Lending at BSI
                     Financial Services
                  </div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Larry is an experienced entrepreneur and financial services industry expert with a demonstrated
                  history of success in Capital Markets and Lending. Over the past seven years, he has helped grow BSI
                  into one of the top 10 buyers of flow mortgage servicing rights and has developed a new
                  retention/refinance lending strategy for the company.<br>

                  Prior to joining BSI, Goldstone was founder and CEO of Aventur Partners, a business consulting and
                  investment advisory firm. He was also the co-founder, CEO and president of Thornburg Mortgage, which
                  he built into one of the most successful public mortgage real estate investment trusts.
               </div>
            </div>
         </li>
      </ul>

   </div>
</div>
